module.exports = __webpack_public_path__ + "media/images/loading-d567660be56bed519c59946c9df22286.svg";